import { EMAIL_TEMPLATE_TYPES } from 'constants/email-config';
import { useTranslation } from 'react-i18next';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { EmailTemplateStep } from 'components/EmailTemplateStep/EmailTemplateStep';

export const SendRefereeRequestModal = ({
  brand = {},
  referee,
  templateIdInBrandDefault,
  visible,
  onClose = () => {},
  onSend = () => {},
}) => {
  const { t } = useTranslation();

  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      title={t('check.refereeRequestEmail.title')}
      noPadding>
      <div className="p-6 max-h-[85vh] overflow-y-auto">
        <p className="text-xl text-neutral-6 mb-4">
          {t('check.refereeRequestEmail.intro', { name: referee?.name ?? '' })}
        </p>
        <EmailTemplateStep
          brand={brand}
          category="referee"
          type={EMAIL_TEMPLATE_TYPES.NEW_REQUEST_TO_REFEREE}
          templateIdInBrandDefault={templateIdInBrandDefault}
          standardName={t('check.refereeRequestEmail.emailStandardName')}
          standardDescription={t('check.refereeRequestEmail.emailStandardDescription')}
          previewStandardMessage={t('check.refereeRequestEmail.emailPreviewStandard')}
          submitLabel={t('check.refereeRequestEmail.sendRequest')}
          onSubmit={templateId => onSend(templateId)}
        />
      </div>
    </AnimatedModal>
  );
};
